// @flow strict

import React from 'react';
import SignUpLayout from '../SignUpLayout';
import styles from './styles.scss';

type PropsType = {|
  title: string,
  subtitle: string,
  subtitle2: string,
  clientName: string,
|};

const ClientExists = ({ title, subtitle, subtitle2, clientName }: PropsType) => {
  const message = (
    <>
      Click on the link in your email to access your
      <br />
      Ansarada profile.
    </>
  );

  return (
    <SignUpLayout title={title} subtitle={subtitle} subtitle2={subtitle2} includeLogInLink={false}>
      <h3 className={styles.title}>Hello {clientName}</h3>

      <p className={styles.message}>{message}</p>
    </SignUpLayout>
  );
};

export default ClientExists;
